// import calculateAge, { findAgeRange } from "../../../utils/commonFunctions/age";

// /* eslint-disable */
// const getStructuredPremiumArray = (schema) => {
// 	// console.log("================================kcjbaksbjhkasbc", schema);
// 	// let keys = Object.keys(schema).filter((key) => schema[key]?.is_present && !key.includes("rider"));
// 	let keys = Object.keys(schema).filter(
// 		(key) => schema[key]?.is_present && !key.includes("rider") && key !== "dependent_eligibility"
// 	);

// 	keys.unshift("carrier_name");
// 	// if (keys.includes("rider")) {
// 	// 	keys = keys.filter((key) => key !== "dependent_eligibility");
// 	// }
// 	const result = keys.join("+");
// 	// console.log("================================kcjbaksbjhkasbc11111111", result);

// 	let structuredKeys;
// 	switch (result.toLocaleLowerCase()) {
// 		case "carrier_name+coverage_for+pay_frequency":
// 			// code block
// 			structuredKeys = ["carrier_name", "coverage_for", "pay_frequency"];
// 			break;
// 		case "carrier_name+coverage_for+coverage_volume+pay_frequency":
// 			// code block
// 			structuredKeys = ["carrier_name", "coverage_volume", "coverage_for", "pay_frequency"];
// 			break;

// 		case "carrier_name+coverage_for+pay_frequency+benefit_amount":
// 			// code block
// 			structuredKeys = ["carrier_name", "coverage_for", "benefit_amount", "pay_frequency"];
// 			break;

// 		case "carrier_name+coverage_for+coverage_volume+pay_frequency+benefit_amount":
// 			// code block
// 			structuredKeys = ["carrier_name", "coverage_volume", "coverage_for", "benefit_amount", "pay_frequency"];
// 			break;
// 		case "carrier_name+coverage_for+pay_frequency+age_criteria":
// 			structuredKeys = ["carrier_name", "coverage_for", "age_criteria", "pay_frequency"];
// 			break;
// 		case "carrier_name+coverage_for+coverage_volume+pay_frequency+age_criteria":
// 			structuredKeys = ["carrier_name", "coverage_volume", "coverage_for", "age_criteria", "pay_frequency"];
// 			break;
// 		case "carrier_name+coverage_for+pay_frequency+benefit_amount+age_criteria":
// 			structuredKeys = ["carrier_name", "coverage_for", "age_criteria", "benefit_amount", "pay_frequency"];
// 			break;
// 		case "carrier_name+coverage_for+coverage_volume+pay_frequency+benefit_amount+age_criteria":
// 			structuredKeys = [
// 				"carrier_name",
// 				"coverage_volume",
// 				"age_criteria",
// 				"coverage_for",
// 				"benefit_amount",
// 				"pay_frequency"
// 			];
// 			break;
// 		default:
// 		// code block
// 	}
// 	console.log("standardPre645========================----------->", structuredKeys);

// 	return structuredKeys;
// };

// export const dynamicPremiumCalculation = async (
// 	schema,
// 	CoverageFor,
// 	coverageVolume,
// 	benefitAmount,
// 	member,
// 	PayFrequency,
// 	isStandardPremium
// ) => {
// 	let standardPremium;
// 	// console.log("standardPremium", schema);
// 	console.log(
// 		"this is the perameters",
// 		schema,
// 		CoverageFor,
// 		coverageVolume,
// 		benefitAmount,
// 		member,
// 		PayFrequency,
// 		isStandardPremium
// 	);
// 	if (isStandardPremium) {
// 		if (CoverageFor === "Employee Only") {
// 			standardPremium = schema.premium_amount["standard_premium"]["employee_premium"];
// 		}
// 		if (CoverageFor === "Spouse Only") {
// 			standardPremium = schema.premium_amount["standard_premium"]["Spouse_premium"];
// 		} else if (CoverageFor === "Child Only") {
// 			standardPremium = schema.premium_amount["standard_premium"]["Child_premium"];
// 		} else {
// 			standardPremium = schema.premium_amount["standard_premium"]["employee_premium"];
// 		}
// 		console.log("this is the standered premium", standardPremium);
// 	} else {
// 		standardPremium = schema.premium_amount["rider1_premium"];
// 	}
// 	console.log("this is the standered premium", standardPremium);

// 	const is_tobacco = member.is_tobacco ? "smoker" : "non_smoker";

// 	const schema_ = isStandardPremium ? schema : schema.rider;

// 	const keys = getStructuredPremiumArray(schema_);
// 	console.log("key=================>111110", keys, standardPremium);

// 	let memberAge = calculateAge(member.date_of_birth, new Date());
// 	if (schema_.age_criteria.is_present && schema_?.age_criteria?.use_age_bands && memberAge) {
// 		memberAge = findAgeRange(memberAge, schema_.age_criteria.age_band_ranges);
// 	}

// 	// console.log("memberAge", memberAge, schema.age_criteria.age_band_ranges);

// 	console.log("schema=================>", schema, standardPremium);
// 	if (schema.is_premium_depends_on_smoke) {
// 		keys.unshift(is_tobacco);
// 	}
// 	// console.log("key=================>111110", keys);

// 	for (const step of keys) {
// 		if (step === "carrier_name") {
// 			continue;
// 		}
// 		console.log("step", step);
// 		switch (step.toLocaleLowerCase()) {
// 			case "standard premium":
// 				standardPremium = premium_amount["standard_premium"];
// 				break;
// 			case "coverage_for":
// 				// code block
// 				standardPremium = standardPremium[CoverageFor];

// 				break;
// 			case "coverage_volume":
// 				standardPremium = standardPremium[coverageVolume];
// 				break;

// 			case "pay_frequency":
// 				standardPremium = standardPremium[PayFrequency];
// 				// code block
// 				break;

// 			case is_tobacco:
// 				standardPremium = standardPremium[is_tobacco];
// 				// code block
// 				break;

// 			case "benefit_amount":
// 				standardPremium = standardPremium[benefitAmount];
// 				// code block
// 				break;

// 			case "age_criteria":
// 				standardPremium = standardPremium[memberAge];
// 				// code block
// 				break;
// 			default:
// 				standardPremium = 0;
// 			// code block
// 		}

// 		console.log("key=================>654654654", standardPremium);

// 		// break
// 	}

// 	console.log("standardPremium==========54----->", standardPremium);
// 	return standardPremium;
// };

import { Schema } from "@mui/icons-material";
import calculateAge, { findAgeRange } from "../../../utils/commonFunctions/age";

/* eslint-disable */
const getStructuredPremiumArray = (schema) => {
	let keys = Object.keys(schema).filter(
		(key) => schema[key]?.is_present && !key.includes("rider") && key !== "dependent_eligibility"
	);

	keys.unshift("carrier_name");

	const result = keys.join("+");
	console.log("this is the keys", keys);
	let structuredKeys;
	switch (result.toLocaleLowerCase()) {
		case "carrier_name+coverage_for+pay_frequency":
			structuredKeys = ["carrier_name", "coverage_for", "pay_frequency"];
			break;
		case "carrier_name+coverage_for+coverage_volume+pay_frequency":
			structuredKeys = ["carrier_name", "coverage_volume", "coverage_for", "pay_frequency"];
			break;
		case "carrier_name+coverage_for+pay_frequency+benefit_amount":
			structuredKeys = ["carrier_name", "coverage_for", "benefit_amount", "pay_frequency"];
			break;
		case "carrier_name+coverage_for+coverage_volume+pay_frequency+benefit_amount":
			structuredKeys = ["carrier_name", "coverage_volume", "coverage_for", "benefit_amount", "pay_frequency"];
			break;
		case "carrier_name+coverage_for+pay_frequency+age_criteria":
			structuredKeys = ["carrier_name", "age_criteria", "coverage_for", "pay_frequency"];
			break;
		case "carrier_name+coverage_for+coverage_volume+pay_frequency+age_criteria":
			structuredKeys = ["carrier_name", "coverage_volume", "age_criteria", "coverage_for", "pay_frequency"];
			break;
		case "carrier_name+coverage_for+pay_frequency+benefit_amount+age_criteria":
			structuredKeys = ["carrier_name", "age_criteria", "coverage_for", "benefit_amount", "pay_frequency"];
			break;
		case "carrier_name+coverage_for+coverage_volume+pay_frequency+benefit_amount+age_criteria":
			structuredKeys = [
				"carrier_name",
				"coverage_volume",
				"age_criteria",
				"coverage_for",
				"benefit_amount",
				"pay_frequency"
			];
			break;
		default:
			console.warn("getStructuredPremiumArray: no matching case for", result);
			structuredKeys = [];
	}

	//console.log("structuredKeys", structuredKeys);
	return structuredKeys;
};

/**
 * The employee sheet is generated from the plan itself, so reading the plan's
 * own flags describes it correctly. A dependent sheet is not: the admin builds
 * it from benefit_amount.<relationship> (see childSchema / spouseSchema in
 * SchemaToExcel.js), which carries its own benefit options and its own age
 * criteria - the "0-1" / "2-26" bands on a child sheet come from
 * benefit_amount.child.age_criteria, never from the employee's age_criteria.
 *
 * This rebuilds that same view so the key order and the age band are read from
 * the schema the sheet was actually generated from.
 */
const getRelationshipSchema = (schema, CoverageFor, isStandardPremium) => {
	const base = (isStandardPremium ? schema : schema?.rider) ?? {};
	const benefitAmounts = base?.benefit_amount ?? {};

	let relationship;
	let dependsOnSmoke;
	if (CoverageFor === "Children Only") {
		relationship = benefitAmounts.child;
		dependsOnSmoke = base.is_premium_depnends_on_child_smoke ?? base.is_premium_depends_on_child_smoke;
	} else if (CoverageFor === "Spouse Only") {
		relationship = benefitAmounts.spouse;
		dependsOnSmoke = base.is_premium_depnends_on_spouse_smoke ?? base.is_premium_depends_on_spouse_smoke;
	} else if (CoverageFor === "Spouse & Children") {
		relationship = benefitAmounts.spouse_and_child;
		dependsOnSmoke = base.is_premium_depends_on_smoke;
	}

	// Employee coverage (and any relationship the plan does not describe
	// separately) is priced off the plan-level schema, exactly as before.
	if (!relationship) return base;

	return {
		...base,
		coverage_for: { is_present: true, options: [CoverageFor] },
		benefit_amount: { ...relationship, is_present: (relationship.options?.length ?? 0) > 0 },
		age_criteria: { ...(relationship.age_criteria ?? {}) },
		is_premium_depends_on_smoke: dependsOnSmoke ?? false
	};
};

export const dynamicPremiumCalculation = async (
	schema,
	CoverageFor,
	coverageVolume,
	benefitAmount,
	member,
	PayFrequency,
	is_tobacco,
	isStandardPremium
) => {
	try {
		console.log(
			"main content",
			// schema,
			CoverageFor,
			coverageVolume,
			benefitAmount,
			// member,
			PayFrequency,
			is_tobacco,
			isStandardPremium
		);
		// The schema the sheet being read was generated from - the plan itself for
		// employee coverage, benefit_amount.<relationship> for a dependent.
		const relationshipSchema = getRelationshipSchema(schema, CoverageFor, isStandardPremium);

		let memberAge = member?.date_of_birth ? calculateAge(member.date_of_birth, new Date()) : NaN;
		const ageBands = relationshipSchema.age_criteria?.age_band_ranges ?? [];
		// Number.isFinite, not a truthiness check: a newborn is age 0, and 0 is
		// exactly the age that belongs in the "0-1" band.
		if (ageBands.length && Number.isFinite(memberAge)) {
			memberAge = findAgeRange(memberAge, ageBands);
		}
		if (!isStandardPremium) {
			const riderSheets = schema.premium_amount ?? {};

			// Each relationship has its own rider sheet, so pick the sheet by the
			// coverage being priced instead of by a fixed order.
			let riderPremium;
			if (CoverageFor === "Spouse Only" && riderSheets["rider_Spouse_premium"]) {
				riderPremium = riderSheets["rider_Spouse_premium"];
			} else if (CoverageFor === "Children Only" && riderSheets["rider_Child_premium"]) {
				riderPremium = riderSheets["rider_Child_premium"];
			} else if (CoverageFor === "Spouse & Children" && riderSheets["rider_Spouse_Child_sheet"]) {
				riderPremium = riderSheets["rider_Spouse_Child_sheet"];
			} else {
				riderPremium = riderSheets["rider_employee_premium"];
			}

			// console.log("riderPremium", riderPremium);
			if (!riderPremium) {
				// console.warn("No rider premium table found for", CoverageFor);
				return 0;
			}

			if (schema.rider?.is_premium_depends_on_smoke) {
				const tobaccoKey = is_tobacco ? "smoker" : "non_smoker";
				if (riderPremium[tobaccoKey] !== undefined) {
					riderPremium = riderPremium[tobaccoKey];
				}
			}

			// Every case in getStructuredPremiumArray nests in this same order, it
			// only varies which levels are present. The rider sheets are built per
			// relationship from schema.rider.benefit_amount[relationship] rather
			// than from schema.rider, so the rider's own is_present flags do not
			// describe them and cannot be used to pick the levels:
			//   rider_Spouse_premium   age -> "Spouse Only"  -> benefit -> frequency
			//   rider_Child_premium           "Children Only" -> benefit -> frequency
			// Walking the full order and skipping absent levels fits both.
			const riderKeys = ["coverage_volume", "age_criteria", "coverage_for", "benefit_amount", "pay_frequency"];
			const descend = (level, key) => {
				if (level === null || typeof level !== "object") return level;
				if (key !== undefined && key !== null && level[key] !== undefined) return level[key];
				return level;
			};

			// Each key consumes at most one level of the sheet. Log the keys left at
			// every level so a mismatch shows which level disagreed rather than
			// only that the result was 0.
			for (const step of riderKeys) {
				// console.log(`rider step [${step}] available keys:`, Object.keys(riderPremium ?? {}));

				switch (step) {
					// coverage_for: relationship label — "Spouse Only" on the spouse
					// sheet, "Children Only" on the child sheet
					case "coverage_for":
						riderPremium = descend(riderPremium, CoverageFor);
						break;

					// coverage_volume: only present when rider.coverage_volume.is_present
					case "coverage_volume":
						riderPremium = descend(riderPremium, coverageVolume);
						break;

					// benefit_amount: sheet keys are strings ("2500"), the form sends a number
					case "benefit_amount":
						riderPremium = descend(riderPremium, String(benefitAmount));
						break;

					// age_criteria: present on the spouse sheet (18-55), absent on
					// the child sheet, where this step is skipped
					case "age_criteria":
						riderPremium = descend(riderPremium, memberAge);
						break;

					// pay_frequency: deepest level, its value is the premium
					case "pay_frequency":
						riderPremium = descend(riderPremium, PayFrequency);
						break;
				}

				if (riderPremium === undefined || riderPremium === null) {
					// console.warn(`Rider premium lookup failed at step: ${step}`, {
					// 	CoverageFor,
					// 	coverageVolume,
					// 	benefitAmount,
					// 	memberAge,
					// 	PayFrequency
					// });
					return 0;
				}
			}

			// Skipping a step leaves an object behind, so only a number is a real hit
			if (typeof riderPremium !== "number") {
				// console.warn("Rider premium did not resolve to an amount", {
				// 	CoverageFor,
				// 	coverageVolume,
				// 	benefitAmount,
				// 	memberAge,
				// 	PayFrequency,
				// 	unresolved: riderPremium && Object.keys(riderPremium)
				// });
				return 0;
			}

			//console.log("rider final premium", riderPremium);
			return riderPremium;
		}
		//console.log("this is working in this==========================>>>>>>>>>>14578");

		const allPremiumSheets = schema.premium_amount["standard_premium"];
		// console.log("allPremiumSheets", allPremiumSheets);

		const isChildCoverage = CoverageFor === "Children Only";
		const isSpouseCoverage = CoverageFor === "Spouse Only";
		//console.log("allPremiumSheets", allPremiumSheets);

		let standardPremium;
		if (
			isSpouseCoverage &&
			allPremiumSheets["Spouse_premium"] &&
			schema?.can_each_relationship_enroll_indipendently_in_this_plan
		) {
			//console.log("this is working1");
			standardPremium = allPremiumSheets["Spouse_premium"];
		} else if (isChildCoverage && allPremiumSheets["Child_premium"]) {
			//console.log("this is working 2");
			standardPremium = allPremiumSheets["Child_premium"];
			console.log("standardPremium", standardPremium);
		} else if (CoverageFor === "Spouse & Children" && allPremiumSheets["Spouse_Child_sheet"]) {
			//console.log("this is working3");
			standardPremium = allPremiumSheets["Spouse_Child_sheet"];
		} else {
			//console.log("thsi is working25346");
			standardPremium = allPremiumSheets["employee_premium"];
		}
		//console.log("standardPremium", standardPremium);
		if (!standardPremium) {
			console.warn("No premium table found for", CoverageFor);
			return 0;
		}

		//console.log("is_tobacco", is_tobacco);
		if (relationshipSchema.is_premium_depends_on_smoke) {
			const tobaccoKey = is_tobacco ? "smoker" : "non_smoker";
			if (standardPremium[tobaccoKey] !== undefined) {
				standardPremium = standardPremium[tobaccoKey];
			}
		}

		console.log("age criteria", memberAge);

		// Read the levels off the schema this sheet was generated from, so a child
		// sheet's age level is walked even when the employee plan has no age
		// criteria of its own.
		const keys = getStructuredPremiumArray(relationshipSchema);
		if (!keys || keys.length === 0) {
			// console.warn("No structured keys found");
			return 0;
		}

		for (const step of keys) {
			if (step === "carrier_name") continue;

			switch (step.toLocaleLowerCase()) {
				case "coverage_for":
					standardPremium = standardPremium[CoverageFor];
					break;
				case "coverage_volume":
					standardPremium = standardPremium[coverageVolume];
					break;
				case "benefit_amount":
					standardPremium = standardPremium[String(benefitAmount)];
					break;
				case "age_criteria":
					// No guards needed any more: getStructuredPremiumArray only lists
					// age_criteria when the relationship being priced actually has it,
					// and memberAge is already banded with that relationship's ranges.
					standardPremium = standardPremium[memberAge];
					break;
				case "pay_frequency":
					standardPremium = standardPremium[PayFrequency];
					break;
			}

			console.log(`after step [${step}]:`, standardPremium);

			if (standardPremium === undefined || standardPremium === null) {
				// console.warn(`Premium lookup failed at step: ${step}`, {
				// 	CoverageFor,
				// 	coverageVolume,
				// 	benefitAmount,
				// 	memberAge,
				// 	PayFrequency
				// });
				return 0;
			}
		}

		console.log("final premium", standardPremium);
		return standardPremium ?? 0;
	} catch (error) {
		// console.error("dynamicPremiumCalculation error", error);
		return 0;
	}
};
